import { useState, useEffect } from 'react'

/* Returns true only on phones (small touch screen, not tablet/desktop) */
export function useIsPhone() {
  const [isPhone, setIsPhone] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia('(pointer: coarse) and (max-width: 767px)').matches
  })
  useEffect(() => {
    const mq = window.matchMedia('(pointer: coarse) and (max-width: 767px)')
    const h = e => setIsPhone(e.matches)
    mq.addEventListener('change', h)
    return () => mq.removeEventListener('change', h)
  }, [])
  return isPhone
}
